<template xmlns="http://www.w3.org/1999/html">
  <div>
    <v-sheet height="800" >
        <v-data-table
          :headers="headers"
          :items="expenses"
          item-key="name"
          :search="search"
          :custom-filter="filterExpensesName"
        >
          <template v-slot:item.receipt_url="{ item }">

            <v-btn icon @click="download_document(item.receipt_url)">
              <v-icon >mdi-download</v-icon>
            </v-btn>
          </template>

          <template v-slot:item.date_of_expense="{ item }">

            {{changeTimestampToDate(item.date_of_expense)}}
          </template>


          <template v-slot:top>
            <v-toolbar
              dark
              dense
              color="#018891"
              class="mb-1"
            >
                <v-text-field
                  v-model="search"
                  clearable
                  flat
                  dense
                  solo-inverted
                  hide-details
                  prepend-inner-icon="mdi-magnify"
                  label="dépense"
                ></v-text-field>
              <v-divider
                class="mx-4"
                inset
                vertical
              ></v-divider>
              <v-spacer></v-spacer>
                <v-dialog
                  v-model="dialog"
                  width="500"
                  transition="dialog-bottom-transition"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      color="#0f3057"
                      dark
                      v-bind="attrs"
                      v-on="on"
                    >
                      Nouvelle dépense
                    </v-btn>
                  </template>
                  <v-toolbar
                    dark
                    color="#0f3057"
                  >
                    <v-btn
                      icon
                      dark
                      @click="dialog = false"
                    >
                      <v-icon>mdi-close</v-icon>
                    </v-btn>
                    <v-toolbar-title>Nouvelle dépense</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-toolbar-items>
                      <v-btn
                        dark
                        text
                        @click="saveNewExpense()"
                      >
                        Save
                      </v-btn>
                    </v-toolbar-items>
                  </v-toolbar>
                  <v-card>
                    <v-col>
                      <v-text-field  v-model="expense_name" label="Nom de dépense" ></v-text-field>
                      <v-text-field  v-model="expense_price"  type="number" label="Prix de dépense"></v-text-field>
                      <v-file-input   accept="image/png, image/jpeg, application/pdf" v-model="expense_receipt_data"label="Reçu"></v-file-input>
                    </v-col>

                  </v-card>
                </v-dialog>
            </v-toolbar>
          </template>

        </v-data-table>
    </v-sheet>
  </div>
</template>

<script>
import firebase from "../firebaseConfig";
import { uuid } from 'vue-uuid';
const db = firebase.firestore();

export default {
  async created() {
    await  this.fetchData();

  },
  data() {
    return {
      search: '',
      dialog: false,
      expenses : [],
      expense_name: "",
      expense_price: "",
      expense_receipt_data: null,

    }
  },
  computed: {
    headers() {
      return [
        {
          text: 'Nom dépense',
          align: 'start',
          sortable: false,
          value: 'name',
        },
        {
          text: 'Prix',
          value: 'price'
        },
        {
          text: "Date",
          value: 'date_of_expense'
        },
        {
          text: "Receipt",
          value: 'receipt_url'
        }
      ]
    }
  },
  methods: {
    filterExpensesName(value, search, item) {
      return value != null &&
        search != null &&
        typeof value === 'string' &&
        value.toString().toLocaleUpperCase().indexOf(search.toString().toLocaleUpperCase()) !== -1;
    },
    download_document(url) {
      var storage = firebase.storage();
      var receiptRef = storage.ref(url);
      receiptRef.getDownloadURL().then((url) =>  window.location.href = url)

    },
    changeTimestampToDate(timestamp){

      if(timestamp == null){
        return "";
      }
      const date = timestamp.toDate()

      return  date.toLocaleDateString("fr-CA")
    },
    saveNewExpense() {

      console.log(this.expense_receipt_data);
      const storage = firebase.storage()
      const storageRef = storage.ref()
      const extension =  this.getFileExtension(this.expense_receipt_data.name);

      const metadata = {
        contentType: this.expense_receipt_data.type
      };
      const filePath = 'receipts/expenses/' + uuid.v1() + extension ;
      storageRef.child(filePath).put(this.expense_receipt_data, metadata).then(() => {
          db.collection("expenses").add({name: this.expense_name, price: this.expense_price, date_of_expense: new Date(), receipt_url: filePath }).then(() => {
            this.fetchData();
          });
      });

      this.dialog = false;
    },
    async fetchData() {
      const querySnapshot =  await db.collection("expenses").get();
      this.expenses =  querySnapshot.docs?.map(doc => doc.data());
    },
    getFileExtension(filename) {
      return filename.substr(filename.lastIndexOf('.') + 1);
    }
  }
}
</script>
